/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Failed_MeasurementInputs */

const en_us2_onboarding_failed_measurement = /** @type {(inputs: Onboarding_Failed_MeasurementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It stopped while saving your weight.`)
};

const pt_br2_onboarding_failed_measurement = /** @type {(inputs: Onboarding_Failed_MeasurementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parou ao salvar seu peso.`)
};

const es_419_onboarding_failed_measurement = /** @type {(inputs: Onboarding_Failed_MeasurementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se detuvo al guardar tu peso.`)
};

const pt_pt2_onboarding_failed_measurement = /** @type {(inputs: Onboarding_Failed_MeasurementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parou ao guardar o teu peso.`)
};

const fr_fr2_onboarding_failed_measurement = /** @type {(inputs: Onboarding_Failed_MeasurementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interrompu pendant l'enregistrement de ton poids.`)
};

const de_de2_onboarding_failed_measurement = /** @type {(inputs: Onboarding_Failed_MeasurementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Speichern deines Gewichts ist es hängen geblieben.`)
};

const it_it2_onboarding_failed_measurement = /** @type {(inputs: Onboarding_Failed_MeasurementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si è interrotto mentre salvava il tuo peso.`)
};

/**
* | output |
* | --- |
* | "It stopped while saving your weight." |
*
* @param {Onboarding_Failed_MeasurementInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_failed_measurement = /** @type {((inputs?: Onboarding_Failed_MeasurementInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Failed_MeasurementInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_failed_measurement(inputs)
	if (locale === "es-419") return es_419_onboarding_failed_measurement(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_failed_measurement(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_failed_measurement(inputs)
	if (locale === "de-DE") return de_de2_onboarding_failed_measurement(inputs)
	if (locale === "it-IT") return it_it2_onboarding_failed_measurement(inputs)
	return en_us2_onboarding_failed_measurement(inputs)
});
export { onboarding_failed_measurement as "onboarding.failed_measurement" }